

//*************************DO NOT MODIFY**************************
//
//THESE FILES ARE AUTOGENERATED WITH TYPEWRITER AND ANY MODIFICATIONS MADE HERE WILL BE LOST
//PLEASE VISIT http://frhagn.github.io/Typewriter/ TO LEARN MORE ABOUT THIS VISUAL STUDIO EXTENSION
//
//*************************DO NOT MODIFY**************************
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ObjectifEditModel } from '../models/ObjectifEditModel';
import { IndicateurStrategiqueEditModel } from '../models/IndicateurStrategiqueEditModel';
import { IndicateurStrategiqueModel } from '../models/IndicateurStrategiqueModel';
import { IndicateurEditModel } from '../models/IndicateurEditModel';
import { TableauBordIndicateurModel } from '../models/TableauBordIndicateurModel';
import { TableauBordDirectionSportModel } from '../models/TableauBordDirectionSportModel';
import { TableauBordFormationModel } from '../models/TableauBordFormationModel';

@Injectable({
   providedIn: 'root'
})
export class IndicateurApiService {
    constructor(private _httpClient: HttpClient) { }        
    
    // get: api/Indicateur/getObjectifsEdit
    getObjectifsEdit(): Observable<ObjectifEditModel[]> {
        var _Url = `api/Indicateur/getObjectifsEdit`;
            return this._httpClient.get<ObjectifEditModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // post: api/Indicateur/saveObjectif
    saveObjectif(objectifEdit: ObjectifEditModel): Observable<ObjectifEditModel> {
        var _Url = `api/Indicateur/saveObjectif`;
            return this._httpClient.post<ObjectifEditModel>(_Url, objectifEdit).pipe(catchError(this.handleError));
    }
    
    // post: api/Indicateur/saveOrdreObjectif
    saveOrdreObjectif(objectifs: ObjectifEditModel[]): Observable<boolean> {
        var _Url = `api/Indicateur/saveOrdreObjectif`;
            return this._httpClient.post<boolean>(_Url, objectifs).pipe(catchError(this.handleError));
    }
    
    // post: api/Indicateur/deleteObjectif?id=${id}
    deleteObjectif(id: number): Observable<boolean> {
        var _Url = `api/Indicateur/deleteObjectif?id=${id}`;
            return this._httpClient.post<boolean>(_Url, id).pipe(catchError(this.handleError));
    }
    
    // post: api/Indicateur/saveIndicateurStrategique
    saveIndicateurStrategique(indicateurStrategiqueEdit: IndicateurStrategiqueEditModel): Observable<IndicateurStrategiqueEditModel> {
        var _Url = `api/Indicateur/saveIndicateurStrategique`;
            return this._httpClient.post<IndicateurStrategiqueEditModel>(_Url, indicateurStrategiqueEdit).pipe(catchError(this.handleError));
    }
    
    // post: api/Indicateur/saveOrdreIndicateurStrategique
    saveOrdreIndicateurStrategique(indicateurStrategiques: IndicateurStrategiqueEditModel[]): Observable<boolean> {
        var _Url = `api/Indicateur/saveOrdreIndicateurStrategique`;
            return this._httpClient.post<boolean>(_Url, indicateurStrategiques).pipe(catchError(this.handleError));
    }
    
    // get: api/Indicateur/getIndicateursStrategiques
    getIndicateursStrategiques(): Observable<IndicateurStrategiqueModel[]> {
        var _Url = `api/Indicateur/getIndicateursStrategiques`;
            return this._httpClient.get<IndicateurStrategiqueModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // post: api/Indicateur/deleteIndicateursStrategique?id=${id}
    deleteIndicateursStrategique(id: number): Observable<boolean> {
        var _Url = `api/Indicateur/deleteIndicateursStrategique?id=${id}`;
            return this._httpClient.post<boolean>(_Url, id).pipe(catchError(this.handleError));
    }
    
    // post: api/Indicateur/saveIndicateur
    saveIndicateur(indicateurEdit: IndicateurEditModel): Observable<IndicateurEditModel> {
        var _Url = `api/Indicateur/saveIndicateur`;
            return this._httpClient.post<IndicateurEditModel>(_Url, indicateurEdit).pipe(catchError(this.handleError));
    }
    
    // post: api/Indicateur/saveOrdreIndicateur
    saveOrdreIndicateur(indicateurs: IndicateurEditModel[]): Observable<boolean> {
        var _Url = `api/Indicateur/saveOrdreIndicateur`;
            return this._httpClient.post<boolean>(_Url, indicateurs).pipe(catchError(this.handleError));
    }
    
    // post: api/Indicateur/deleteIndicateur?id=${id}
    deleteIndicateur(id: number): Observable<boolean> {
        var _Url = `api/Indicateur/deleteIndicateur?id=${id}`;
            return this._httpClient.post<boolean>(_Url, id).pipe(catchError(this.handleError));
    }
    
    // get: api/Indicateur/getIndicateurNationalPerformance?etablissementId=${etablissementId}&siteId=${siteId}&annee=${annee}
    getIndicateurNationalPerformance(etablissementId: number, siteId: number, annee: number): Observable<TableauBordIndicateurModel> {
        var _Url = `api/Indicateur/getIndicateurNationalPerformance?etablissementId=${etablissementId}&siteId=${siteId}&annee=${annee}`;
            return this._httpClient.get<TableauBordIndicateurModel>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Indicateur/getTableauBordDirectionSport?annee=${annee}
    getTableauBordDirectionSport(annee: number): Observable<TableauBordDirectionSportModel> {
        var _Url = `api/Indicateur/getTableauBordDirectionSport?annee=${annee}`;
            return this._httpClient.get<TableauBordDirectionSportModel>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Indicateur/getTableauDeBordFormation?etablissementId=${etablissementId}&annee=${annee}
    getTableauDeBordFormation(etablissementId: number, annee: number): Observable<TableauBordFormationModel> {
        var _Url = `api/Indicateur/getTableauDeBordFormation?etablissementId=${etablissementId}&annee=${annee}`;
            return this._httpClient.get<TableauBordFormationModel>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Indicateur/getRapportIndicateurNationalPerformanceDownload?etablissementId=${etablissementId}&siteId=${siteId}&annee=${annee}
    getRapportIndicateurNationalPerformanceDownload(etablissementId: number, siteId: number, annee: number): Observable<HttpResponse<Blob>> {
        var _Url = `api/Indicateur/getRapportIndicateurNationalPerformanceDownload?etablissementId=${etablissementId}&siteId=${siteId}&annee=${annee}`;
            return this._httpClient.get(_Url, { observe: 'response', responseType: 'blob' }).pipe(catchError(this.handleError));
    }
    
    // get: api/Indicateur/getRapportPdfIndicateurNationalPerformanceDownload?etablissementId=${etablissementId}&siteId=${siteId}&annee=${annee}
    getRapportPdfIndicateurNationalPerformanceDownload(etablissementId: number, siteId: number, annee: number): Observable<HttpResponse<Blob>> {
        var _Url = `api/Indicateur/getRapportPdfIndicateurNationalPerformanceDownload?etablissementId=${etablissementId}&siteId=${siteId}&annee=${annee}`;
            return this._httpClient.get(_Url, { observe: 'response', responseType: 'blob' }).pipe(catchError(this.handleError));
    }
    
    // get: api/Indicateur/getRapportPdfIndicateurNationalPerformanceGraphiqueDownload?etablissementId=${etablissementId}&siteId=${siteId}&annee=${annee}
    getRapportPdfIndicateurNationalPerformanceGraphiqueDownload(etablissementId: number, siteId: number, annee: number): Observable<HttpResponse<Blob>> {
        var _Url = `api/Indicateur/getRapportPdfIndicateurNationalPerformanceGraphiqueDownload?etablissementId=${etablissementId}&siteId=${siteId}&annee=${annee}`;
            return this._httpClient.get(_Url, { observe: 'response', responseType: 'blob' }).pipe(catchError(this.handleError));
    }
    
    // get: api/Indicateur/getRapportIndicateurNationalPerformanceGraphiqueDownload?etablissementId=${etablissementId}&siteId=${siteId}&annee=${annee}
    getRapportIndicateurNationalPerformanceGraphiqueDownload(etablissementId: number, siteId: number, annee: number): Observable<HttpResponse<Blob>> {
        var _Url = `api/Indicateur/getRapportIndicateurNationalPerformanceGraphiqueDownload?etablissementId=${etablissementId}&siteId=${siteId}&annee=${annee}`;
            return this._httpClient.get(_Url, { observe: 'response', responseType: 'blob' }).pipe(catchError(this.handleError));
    }
    
    // get: api/Indicateur/getRapportFormationDownload?etablissementId=${etablissementId}&annee=${annee}
    getRapportFormationDownload(etablissementId: number, annee: number): Observable<HttpResponse<Blob>> {
        var _Url = `api/Indicateur/getRapportFormationDownload?etablissementId=${etablissementId}&annee=${annee}`;
            return this._httpClient.get(_Url, { observe: 'response', responseType: 'blob' }).pipe(catchError(this.handleError));
    }
    
    // get: api/Indicateur/getRapportPdfFormationDownload?etablissementId=${etablissementId}&annee=${annee}
    getRapportPdfFormationDownload(etablissementId: number, annee: number): Observable<HttpResponse<Blob>> {
        var _Url = `api/Indicateur/getRapportPdfFormationDownload?etablissementId=${etablissementId}&annee=${annee}`;
            return this._httpClient.get(_Url, { observe: 'response', responseType: 'blob' }).pipe(catchError(this.handleError));
    }
    
    // get: api/Indicateur/getRapportTableauBordDirectionSportDownload?annee=${annee}
    getRapportTableauBordDirectionSportDownload(annee: number): Observable<HttpResponse<Blob>> {
        var _Url = `api/Indicateur/getRapportTableauBordDirectionSportDownload?annee=${annee}`;
            return this._httpClient.get(_Url, { observe: 'response', responseType: 'blob' }).pipe(catchError(this.handleError));
    }
    
    // get: api/Indicateur/getRapportPdfTableauBordDirectionSportDownload?annee=${annee}
    getRapportPdfTableauBordDirectionSportDownload(annee: number): Observable<HttpResponse<Blob>> {
        var _Url = `api/Indicateur/getRapportPdfTableauBordDirectionSportDownload?annee=${annee}`;
            return this._httpClient.get(_Url, { observe: 'response', responseType: 'blob' }).pipe(catchError(this.handleError));
    }
    
    // get: api/Indicateur/getExportIndicateurNationalPerformanceDownload?etablissementId=${etablissementId}&siteId=${siteId}&annee=${annee}
    getExportIndicateurNationalPerformanceDownload(etablissementId: number, siteId: number, annee: number): Observable<HttpResponse<Blob>> {
        var _Url = `api/Indicateur/getExportIndicateurNationalPerformanceDownload?etablissementId=${etablissementId}&siteId=${siteId}&annee=${annee}`;
            return this._httpClient.get(_Url, { observe: 'response', responseType: 'blob' }).pipe(catchError(this.handleError));
    }
    
    // get: api/Indicateur/getExportMobilisationDownload?siteId=${siteId}&annee=${annee}
    getExportMobilisationDownload(siteId: number, annee: number): Observable<HttpResponse<Blob>> {
        var _Url = `api/Indicateur/getExportMobilisationDownload?siteId=${siteId}&annee=${annee}`;
            return this._httpClient.get(_Url, { observe: 'response', responseType: 'blob' }).pipe(catchError(this.handleError));
    }
    
    // get: api/Indicateur/getExportMobilisationPdfDownload?siteId=${siteId}&annee=${annee}
    getExportMobilisationPdfDownload(siteId: number, annee: number): Observable<HttpResponse<Blob>> {
        var _Url = `api/Indicateur/getExportMobilisationPdfDownload?siteId=${siteId}&annee=${annee}`;
            return this._httpClient.get(_Url, { observe: 'response', responseType: 'blob' }).pipe(catchError(this.handleError));
    }
    
    // Utility
    private handleError(error: HttpErrorResponse) {
        console.error(error);
        let customError: string = "";
        if (error.error) {
            customError = error.status === 400 ? error.error : error.statusText
        }
        return throwError(customError || 'Server error');
    }
}
